















































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import FgrUserData from './c-frg-data/Index.vue';
import KatUserData from './c-kat-data/Index.vue';
import AbpUserData from './c-abp-data/Index.vue';
import RegionUserData from './c-region-data/Index.vue';
import KatoUserData from './c-kato-data/Index.vue';
import GuUserData from './c-gu-data/Index.vue';
import KgkpUserData from './c-kgkp-data/Index.vue';
import GuUsers from './c-gu-users/Index.vue';
import MsuUserData from './c-msu-data/Index.vue';
import ModulesUserData from './c-modules-data/Index.vue';
import './user-management.scss';
import {IKeyCloakUser, IUserOperations} from './user-management-int';
import UtilUI from './util-ui';
import WorkplaceUserData from "@/modules/user-management/c-workplace-data/Index.vue";
import WorkplaceUserGkkpData from "@/modules/user-management/c-workplace-gkkp-data/Index.vue";
import WorkplaceUsers from "@/modules/user-management/c-workplace-users/Index.vue";
import BaseUserLink from './base-user-link';
import store from "@/services/store";
import axios from "axios";
import { umFetch } from '@/modules/user-management/services/umFetch';

@Component({
    components: {
        FgrUserData,
        AbpUserData,
        RegionUserData,
        GuUserData,
        MsuUserData,
        KatUserData,
        KatoUserData,
        ModulesUserData,
        GuUsers,
        KgkpUserData,
        WorkplaceUserData,
        WorkplaceUserGkkpData,
        WorkplaceUsers
    }
})

export default class UserManagement extends UtilUI {
    private userFilter = '';
    private userList: any = [];
    private filteredUserList: any = [];
    private selectedUser: IKeyCloakUser | null = null;
    private sourceUser: IKeyCloakUser | null = null;
    private activeTab = 0;
    private oblRegion = this.$store.state._instanceCode;
    private operations: any = [];
    private realm_user_count = 0;
    private isReduceUser: boolean = false;
    private isSupportUser: boolean = false;
    private hasUmAccess: boolean = false;
  

    @Watch('selectedUser')
    async onUserChanged(value: IKeyCloakUser, oldValue: IKeyCloakUser) {
        await this.get_user_is_support(value);
        await this.fetchUserReduce(value.id);
    }
async fetchUserReduce(userId: string) {
    try {
      const response = await axios.get(`/api/um/user-reduce/${userId}`);
      this.isReduceUser = response.data && response.data.length > 0;
    } catch (error) {
      console.error("Ошибка при получении настроек:", error);
    }
  }

  async saveUserReduce(user: IKeyCloakUser) {
    if (!this.selectedUser) return;
      const saveData = {
            user_id: user.id,
            vals: [
                {
                    item: this.isReduceUser
                }
            ]
        };
        try {
            await fetch('/api/um/save-user-reduce', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(saveData)
            });
        } catch (error) {
            this.makeToast('danger', 'Ошибка сохранения данных: ' + user.id, error.toString());
        }
}


    async get_user_is_support(user: IKeyCloakUser) {
        const response = await fetch('/api/um/user-support/'+user.id);
        if (response.status === 200) {
            const data = await response.json()
            this.$set(user, "is_support", data[0])
        }
    }

    async save_user_is_support(user: IKeyCloakUser) {
        const saveData = {
            user_id: user.id,
            vals: [
                {
                    item: user.is_support
                }
            ]
        };
        try {
            await fetch('/api/um/save-user-support', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(saveData)
            });
        } catch (error) {
            this.makeToast('danger', 'Ошибка сохранения данных: ' + user.id, error.toString());
        }
    }

   private activateTab(id: number) {
    this.activeTab = id;
    console.debug("Tab changed:", id, this.$store.getters.user_uuid, this.$store.state._instanceCode);
}


protected get isHasUmAdminRole(): boolean {
  const roles = store.getters.user?.roles || [];
  return Array.isArray(roles) && roles.includes("um_admin");
}


  private async clone_user() {
    const mesRes = await this.showMsgBoxOne(
        'Создать пользователя на основе образца?',
        {
            okTitle: 'Создать',
            cancelTitle: 'Не создавать',
        }
    );

    if (!mesRes) {
        return;
    }

    try {
        const response = await umFetch(
            '/api-py/clone-user-data/' +
                this.sourceUser?.id +
                '/' +
                this.selectedUser?.id,
            {
                method: 'GET',
                targetUserId: this.selectedUser?.id,
                headers: {
                    Authorization: `Bearer ${this.$store.getters.token}`,
                },
            }
        );

        if (response.status === 200) {
            this.makeToast(
                'success',
                'Сообщение',
                'Настройки скопированы'
            );

            this.activateTab(0);
        }
    } catch (error) {
        this.makeToast(
            'danger',
            'Ошибка копирования пользователя',
            error.toString()
        );
    }
}

    private async showMsgBoxOne(question: string, options: object) {
        const res = await this.$bvModal.msgBoxConfirm(question, options);
        return res;
    }

    private get userFiltered() {
        const res = [];
        for (const item of this.userList) {
            if (item.username.toString().includes(this.userFilter)) {
                res.push(item);
            }
            else if ((item.firstName) && (item.firstName.toString().includes(this.userFilter))) {
                res.push(item);
            }
            else if ((item.lastName) &&  (item.lastName.toString().includes(this.userFilter))) {
                res.push(item);
            }
        }
        return res
    }

    private async loadUsers() {
        try {
            const response = await fetch('/api-py/get-realm-users-fast/');
            this.userList = await response.json() as IKeyCloakUser;
            this.userList = this.userList.reverse();
            this.filteredUserList = this.userList;
        } catch (error) {
            this.makeToast('danger', 'Ошибка загрузки пользователей', error.toString());
        }
    }

    private onUserSearchChange(query: string) {
        const q = query.trim().toLowerCase();
        if (!q) {
            this.filteredUserList = this.userList;
            return;
        }
        this.filteredUserList = this.userList.filter(
            (item: IKeyCloakUser) =>
                item.username?.toLowerCase().includes(q) ||
                item.firstName?.toLowerCase().includes(q) ||
                item.lastName?.toLowerCase().includes(q) ||
                item.id?.toLowerCase().includes(q)
        );
    }

    private async loadUsersCount() {
        try {
            const response = await fetch('/api-py/get-realm-users-count');
            this.realm_user_count = await response.json() as number;
        } catch (error) {
            this.makeToast('danger', 'Ошибка загрузки пользователей', error.toString());
        }
    }

    protected selectUser(user: IKeyCloakUser) {
        this.selectedUser = user;
    }

    async getObl() {
        try {
            await fetch('/api-py/get-budget-obl/' + this.$store.state._instanceCode)
                .then(response => response.json())
                .then(json => {
                    this.oblRegion = json.obl;
                    // this.region = json.region;
                });

        } catch (error) {
            this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
        }
    }

    private async loadDictOperations() {
        try {
            const response = await fetch("/api/dict/user-operations");
            this.operations = (await response.json()) as IUserOperations;
            this.operations = [...this.operations];
            } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка загрузки операция пользователя",
                error.toString()
            );
        }
    }

private async checkUmAccess(): Promise<boolean> {
  const roles = store.getters.user?.roles || [];
  const isAdmin = Array.isArray(roles) && roles.includes("um_admin");

  console.log("[UM][access] roles:", roles);
  console.log("[UM][access] isAdmin:", isAdmin);

  if (isAdmin) {
    this.hasUmAccess = true;
    console.log("[UM][access] BYPASS granted (um_admin=true). hasUmAccess=", this.hasUmAccess);
    return true;
  }
  const uidFromSub = store.getters.user?.sub;
  const uidFromGetter = this.$store.getters.user_uuid;
  const uid = uidFromSub || uidFromGetter;

  console.log("[UM][access] uidFromSub:", uidFromSub);
  console.log("[UM][access] uidFromGetter:", uidFromGetter);
  console.log("[UM][access] uidUsed:", uid);

  if (!uid) {
    this.hasUmAccess = false;
    console.warn("[UM][access] DENY: uid is empty");
    return false;
  }

  try {
    const url = `/api-py/check-user-mode?uid=${encodeURIComponent(uid)}&um_admin=false`;
    console.log("[UM][access] request URL:", url);

    const response = await fetch(url);

    console.log("[UM][access] response.status:", response.status);
    console.log("[UM][access] response.ok:", response.ok);

    if (!response.ok) {
      this.hasUmAccess = false;
      console.warn("[UM][access] DENY: response not ok");
      return false;
    }

    const data = await response.json();
    console.log("[UM][access] response.data:", data);

    this.hasUmAccess = data?.has_mode === true;
    console.log("[UM][access] FINAL hasUmAccess:", this.hasUmAccess);

    return this.hasUmAccess;

  } catch (e) {
    console.error("[UM][access] ERROR:", e);
    this.hasUmAccess = false;
    return false;
  }
}

public async mounted() {
  const ok = await this.checkUmAccess();
  if (!ok) return; 

  await this.loadUsers();
  await this.getObl();
  await this.loadDictOperations();
  await this.loadUsersCount();
}


    private getLabel(item: any):string {
        return `${item.username} — ${item.firstName} ${item.lastName||''}`
    }
}
